import type { ComponentType } from "react";
import { useParams, Navigate } from "infrastructure/router";
import { WebRoutes } from "consts/enpoints/web";
import type { PlatformSetupRouteParams } from "./types";

const withIndexRedirect = <TProps extends object>(Component: ComponentType) =>
    (props: TProps) => {
        const { platform, step } = useParams<PlatformSetupRouteParams>();

        if (!Number(step)) {
            return (
                <Navigate
                    to={[WebRoutes.ECommerce.Platforms, platform, 1].join('/')}
                />
            );
        }

        return (
            <Component
                {...props}
            />
        );
    };

export default withIndexRedirect;
